import React from 'react';
import {Button, Container, Grid, Icon, Table} from "semantic-ui-react";
import './Report.css';

const renderTeam = (team) => {
    return (
        team.map((position) => {
            console.log(position);
            return (
                <div className={'position'}>
                    <h3>{position.position_title} <span className={'quantity'}><Icon name='users' /> {position.quantity}</span></h3>
                    <Table compact='very' color={'blue'} striped stackable selectable fixed>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Rate</Table.HeaderCell>
                                <Table.HeaderCell>For One Position</Table.HeaderCell>
                                <Table.HeaderCell>Total</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>Hourly Rate</Table.Cell>
                                <Table.Cell>${position.position_hourly_rate}</Table.Cell>
                                <Table.Cell className={'total-rate'}>${position.total_hourly_rate}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Monthly Rate</Table.Cell>
                                <Table.Cell>${position.position_monthly_rate}</Table.Cell>
                                <Table.Cell className={'total-rate'}>${position.total_monthly_rate}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Yearly Rate</Table.Cell>
                                <Table.Cell>${position.position_yearly_rate}</Table.Cell>
                                <Table.Cell className={'total-rate'}>${position.total_yearly_rate}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </div>
            );
        })
    )
};

const Report = (props) => {
    return (
        <Grid id={'report'}>
            <Grid.Row>
            <Grid.Column padded={'horizontally'}>
                <Container className={"report"}>
                    <h2 className={'title'}>Hello {props.report.options.name}, <br></br> let's summarize your Project!</h2>

                    <Grid divided='vertically'>
                        <Grid.Row columns={2}>
                            <Grid.Column>
                                <span className={'label'}>Date</span>
                                <div className={'output'}>{props.report.options.date}</div>
                            </Grid.Column>
                            <Grid.Column>
                                <span className={'label'}>Team Location</span>
                                <div className={'output'}>{props.report.options.target_location}</div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={1}>
                            <Grid.Column>
                                <span className={'label'}>Deadline</span>
                                <div className={'output'}>{props.report.options.deadline}</div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={1}>
                            <Grid.Column>
                                <span className={'label'}>Message</span>
                                <div className={'output message'}>{props.report.options.message}</div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Container>
                <Container className={"report"}>
                    <h2 className={'title'}>Your Team</h2>
                    {renderTeam(props.report.positions)}
                </Container>
            </Grid.Column>
            </Grid.Row>
            <Grid.Row className={"total-team-rate"}>
                <Grid.Column>
                    <Container className={"report"}>
                        <h2 className={'title'}>Total Team Rate</h2>
                        <div className={'sub-title'}>The total cost of your development team per month and year</div>

                        <Table striped stackable selectable fixed>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>Hourly Rate</Table.Cell>
                                    <Table.Cell>${props.report.options.team_hourly_rate}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>Monthly Rate</Table.Cell>
                                    <Table.Cell>${props.report.options.team_monthly_rate}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>Yearly Rate</Table.Cell>
                                    <Table.Cell>${props.report.options.team_yearly_rate}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                        <Button floated={'right'} color={'blue'} onClick={()=>{window.print()}}><Icon name='print' /> Print report</Button>
                    </Container>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
};


export default Report;